import { apiClient, getToken, getOrgId } from '@devd-client/api';
import { BottomViewResponse } from '../helpers/bottomView.types';

export const getIntegrationDetails = (id: string): Promise<any> =>
  apiClient(`/v1/integration/${id}/org/${getOrgId()}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getIssueTypeMap = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/issueType`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};
export const updateIssueTypeMap = (params: any): Promise<any> => {
  const { name, ...restParams } = params;
  return apiClient(`/v1/integration/${name}/org/${getOrgId()}/issueType`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(restParams),
  });
};

export const integrateRequest = (params: any): Promise<any> => {
  return apiClient(`/v1/integration/${params.name}/org/${getOrgId()}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const getBottomView = (
  integrationId: string
): Promise<BottomViewResponse> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/fieldMap`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const addUpdateBottomView = (params: any): Promise<any> => {
  return apiClient(
    `/v1/integration/${params?.integrationId}/org/${getOrgId()}/fieldMap`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.data),
    }
  );
};

export const getTableView = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/projects`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const getProjects = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/projects`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const addUpdateProjects = (params: any): Promise<any> => {
  return apiClient(
    `/v1/integration/${params.integrationId}/org/${getOrgId()}/project`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.data),
    }
  );
};

export const getIssueStatuses = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/issueStatuses`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const getConfiguredIssueStatus = (
  integrationId: string
): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/stageConfig`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postConfiguredIssueStatus = (params: any): Promise<any> => {
  const { integrationId, ...data } = params;
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/stageConfig`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    }
  );
};

export const getQualityConfig = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/qualityConfig`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postQualityConfig = (params: any): Promise<any> => {
  const { integrationId, ...data } = params;
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/qualityConfig`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    }
  );
};

export const getStatusCategory = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/statusCategory`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postStatusCategory = (params: any): Promise<any> => {
  const { integrationId, ...data } = params;
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/statusCategory`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    }
  );
};

export const getProdBugs = (integrationId: string): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/prodBugsConfiguration`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postProdBugs = (params: any): Promise<any> => {
  const { integrationId, ...data } = params;
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/prodBugsConfiguration`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    }
  );
};

export const getMetricStatusExclusion = (
  integrationId: string
): Promise<any> => {
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/metricStatusExclusion`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postMetricStatusExclusion = (params: any): Promise<any> => {
  const { integrationId, ...data } = params;
  return apiClient(
    `/v1/integration/${integrationId}/org/${getOrgId()}/metricStatusExclusion`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    }
  );
};
